import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { IParametrosLocais } from 'src/integracoes/servicos/mongo-atlas/modelos/IParametrosLocais';
import { getParametrosLocaisSuccess, parametrosLocaisErrorMsg, updateParametrosLocaisSuccess } from './actions';
import { GET_PARAMETROS_LOCAIS_INIT, UPDATE_PARAMETROS_LOCAIS_INIT } from '../actionTypes';
import { atualizarParametrosLocais, listarParametrosLocais } from 'src/integracoes/servicos/mongo-atlas/funcoes/parametrosLocais';

// -------------------Obter Paramêtros Locais-----------------------------
const fetchObtemParametrosLocais = async (id: string) => {
  try {
    const { status, dados, mensagem } = await listarParametrosLocais(id);

    if (status) {
      return {
        isError: false,
        parametrosLocais: dados,
        errorMessage: ''
      };
    }
    return {
      isError: true,
      parametrosLocais: null,
      errorMessage: mensagem
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObtemParametrosLocais({ payload }: { payload: any, type: any }) {
  const { id } = payload;
  
  try {
    const { isError, parametrosLocais, errorMessage } = yield call(fetchObtemParametrosLocais, id);
    if (!isError) {
      yield put(getParametrosLocaisSuccess({ parametrosLocais }));
    } else {
      yield put(parametrosLocaisErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(parametrosLocaisErrorMsg({ msg: mensagem }));
  }
}

export function* watchObtemParametrosLocais() {
  yield takeEvery(GET_PARAMETROS_LOCAIS_INIT, parseObtemParametrosLocais);
}

// --------------------------- Atualiza Paramêtros Locais ---------------------------------------------------------
const fetchAtualizaParametrosLocais = async (id: string, parametros: IParametrosLocais) => {
  try {
    const { status, dados, mensagem } = await atualizarParametrosLocais(id, parametros);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizaParametrosLocais({ payload }: { payload: any, type: any }) {
  const { id, parametros } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizaParametrosLocais, id, parametros);
    if (isUpdated) {
      yield put(updateParametrosLocaisSuccess({ msg }));
    } else {
      yield put(parametrosLocaisErrorMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(parametrosLocaisErrorMsg({ msg: mensagem }));
  }
}

export function* watchAtualizaParametrosLocais() {
  yield takeEvery(UPDATE_PARAMETROS_LOCAIS_INIT, parseAtualizaParametrosLocais);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchObtemParametrosLocais),
    fork(watchAtualizaParametrosLocais)
  ]);
}